//Parroquias Cojedes
const munAnzoategui = ['Cojedes', 'Juan de Mata Suárez'];
const munTinaquillo = ['Tinaquillo'];
const munGirardotCojedes = ['El Baúl', 'Sucre'];
const munLimaBlanco = ['Macapo', 'La Aguadita'];
const munPaoDeSanJuanBautista = ['El Pao'];
const munRicaurte = ['Libertad De Cojedes', 'El Amparo'];
const munRomuloGallegosCojedes = ['Rómulo Gallegos'];
const munEzequielZamoraCojedes = [
  'San Carlos De Austria',
  'Juan Ángel Bravo',
  'Manuel Manrique',
];
const munTinaco = ['General En Jefe José Laurencio Silva'];
export const esCojedes = [
  {
    municipio: 'Anzoátegui',
    parroquias: munAnzoategui,
  },
  {
    municipio: 'Tinaquillo',
    parroquias: munTinaquillo,
  },
  {
    municipio: 'Girardot',
    parroquias: munGirardotCojedes,
  },
  {
    municipio: 'Lima Blanco',
    parroquias: munLimaBlanco,
  },
  {
    municipio: 'Pao De San Juan Bautista',
    parroquias: munPaoDeSanJuanBautista,
  },
  {
    municipio: 'Romulo Gallegos',
    parroquias: munRomuloGallegosCojedes,
  },
  {
    municipio: 'Ricaurte',
    parroquias: munRicaurte,
  },
  {
    municipio: 'Ezequiel Zamora',
    parroquias: munEzequielZamoraCojedes,
  },
  {
    municipio: 'Tinaco',
    parroquias: munTinaco,
  },
];
